module.exports = __webpack_public_path__ + "img/meh-smiley.0e8f86ad.svg";